export default __webpack_public_path__ + "static/media/skincode.9f01784e.png";